import React, { useState, useCallback } from 'react';

import { InputItemProps } from './type';
import { removeBlankSpace } from '../../utils/tools';

const InputItem = (props: InputItemProps) => {
  const {
    name,
    onChange,
    prefix,
    suffix,
    dataBind,
    placeholder,
    type = 'text',
    width,
    style,
    defaultValue = '',
    readonly,
    clearBlank = true,
  } = props;

  const [tempValue, setTempValue] = useState(defaultValue);

  const handleValue = useCallback((val) => {
    return clearBlank ? removeBlankSpace(val) : val;
  }, [clearBlank]);

  // 子组件change事件
  const onInputChange = (e: any, fromBlur: boolean = false) => {
    const filterValue = fromBlur ? handleValue(e.target.value) : e.target.value;
    setTempValue(filterValue);
    const newName = dataBind || name;
    const newValue = { name: newName, value: filterValue };

    onChange && onChange(newValue);
  };

  const styleObj = {
    width,
    ...style,
  };

  return (
    <>
      { prefix && <span>{prefix}</span> }
      <input
        className="input-item-cls"
        style={styleObj}
        type={type}
        value={tempValue}
        placeholder={placeholder}
        onChange={onInputChange}
        readOnly={readonly}
        onBlur={(e) => onInputChange(e, true)}
      />
      { suffix && <span>{suffix}</span> }
    </>
  );
};

export default InputItem;
